import {AfterViewInit, Component, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import {JwtHelperService} from "@auth0/angular-jwt";
import {ProfileMessage} from "../../_services/profile.message";
import {AuthService} from "../login/services/auth.service";
import {environment} from "../../../environments/environment";
@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
})
export class LandingComponent implements OnInit, AfterViewInit {
  isLoggedIn = false;
  content?: string;
  user: any;
  env: string;
  constructor(
    private jwtHelper: JwtHelperService,
    private router: Router,
    private profileMsg: ProfileMessage,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
      this.env = environment.env;
      if(this.env == 'production') {
        console.log(this.env, 'called this')
        window.location.href = 'https://getcertwallet.com';
      } else {
        this.isLoggedIn = !this.jwtHelper.isTokenExpired();
        if (this.isLoggedIn) {
          this.profileMsg.currentMessage.subscribe(r => {
            if(r) {
              this.user = r;
              if (this.user.accountType == 'FREE') {
                this.router.navigateByUrl('/billing').then();
              } else {
                this.router.navigate(['/dashboard']).then();
              }
            } else {
              this.authService.profile().then(rx => {
                this.user = rx;
                if (this.user.accountType == 'FREE') {
                  this.router.navigateByUrl('/billing').then();
                } else {
                  this.router.navigate(['/dashboard']).then();
                }
              }, _ => {
                localStorage.clear();
              })
            }
          })
        }
      }
  }

  ngAfterViewInit() {
    if(this.env == 'production') {
        window.location.href = 'https://getcertwallet.com';
    }
  }

  login(): void {
    this.router.navigateByUrl('/login').then();
  }

  register(): void {
    this.router.navigateByUrl('/register').then();
  }
}
